import {lazy} from "react"

const Dashboard = lazy(() => import("../pages/dashboard/"))
const WorkSpace = lazy(() => import("../pages/workspace/"))
const WorkSpaceDetail = lazy(() => import("../pages/workspace-detail/"))
const Profile = lazy(() => import("../pages/profile/"))

const routes = [
  {
    path: "/dashboard",
    exact: true,
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/workspace",
    exact: true,
    name: "WorkSpace",
    component: WorkSpace
  },
  {
    path: "/workspace/:id",
    exact: true,
    name: "WorkSpaceDetail",
    component: WorkSpaceDetail
  },
  {
    path: "/profile",
    exact: true,
    name: "Profile",
    component: Profile
  }
]

export default routes
